var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.286,
    height: 23.287,
    viewBox: "0 0 23.286 23.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112919",
    "data-name": "Group 112919",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112918",
    "data-name": "Group 112918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112917",
    "data-name": "Group 112917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112916",
    "data-name": "Group 112916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112915",
    "data-name": "Group 112915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-info",
    "data-name": "Icon feather-info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106887",
    "data-name": "Path 106887",
    d: "M24.786,13.893A10.893,10.893,0,1,1,13.893,3,10.893,10.893,0,0,1,24.786,13.893Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#3384ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106888",
    "data-name": "Path 106888",
    d: "M18,22.357V18",
    transform: "translate(-7.107 -7.107)",
    fill: "none",
    stroke: "#3384ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106889",
    "data-name": "Path 106889",
    d: "M18,12h0",
    transform: "translate(-7.107 -5.464)",
    fill: "none",
    stroke: "#3384ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfo);
export default __webpack_public_path__ + "static/media/blue_info.532990467515939328592410ec24f2c3.svg";
export { ForwardRef as ReactComponent };